import { PageStructuredData } from '../root/PageStructuredData';
import type { RouteMetaPayload } from '../../_libs/site-shell/routeMeta';
import { RouteMeta } from './RouteMeta';

export function PageRouteMeta(props: RouteMetaPayload) {
  const { metaProps } = props;

  return (
    <>
      {metaProps ? <PageStructuredData metaProps={metaProps} /> : null}
      <RouteMeta {...props} />
    </>
  );
}
